import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HomePage from "pages/HomePage";
import HowItWorksPage from "pages/HowItWorksPage";
import CardBenefitsPage from "pages/CardBenefitsPage";
import FAQPage from "pages/FAQPage";
import ApplyPage from "pages/ApplyPage";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Home route */}
          <Route path="/" element={<HomePage />} />
          
          {/* How It Works route */}
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          
          {/* Card & Benefits route */}
          <Route path="/card-benefits" element={<CardBenefitsPage />} />
          
          {/* FAQ route */}
          <Route path="/faq" element={<FAQPage />} />
          
          {/* Apply/Eligibility route */}
          <Route path="/apply" element={<ApplyPage />} />
          
          {/* 404 catch-all route */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;